import React from "react";
import Reveal from "@/components/site/Reveal";

/**
 * Vertical journey visualisation for "How We Work".
 * Renders a connecting line with an animated pulse moving downward,
 * plus per-stage cards.
 */
export default function ProcessTimeline({ steps }) {
  return (
    <div className="relative">
      {/* Connecting line with animated pulse */}
      <svg
        aria-hidden
        className="absolute left-[19px] top-2 h-full w-[2px] overflow-visible"
        preserveAspectRatio="none"
      >
        <line
          x1="1"
          x2="1"
          y1="0"
          y2="100%"
          stroke="#e5e5ea"
          strokeWidth="1"
        />
        <line
          x1="1"
          x2="1"
          y1="0"
          y2="100%"
          stroke="#0a0a0a"
          strokeOpacity="0.6"
          strokeWidth="1"
          strokeDasharray="4 6"
          className="mts-pulse-line"
        />
      </svg>

      <ol className="space-y-6">
        {steps.map((s, i) => (
          <Reveal key={s.n} delay={i * 40}>
            <li className="relative pl-14">
              {/* node dot */}
              <span
                aria-hidden
                className="absolute left-0 top-1 flex h-10 w-10 items-center justify-center rounded-full bg-white border border-[#e5e5ea] text-[11px] font-medium text-[#0a0a0a] shadow-[0_1px_0_rgba(0,0,0,0.02)]"
              >
                {s.n}
                <span className="absolute inset-0 rounded-full bg-[#0a0a0a] opacity-0 group-hover:opacity-100 transition-opacity" />
              </span>
              <div className="mts-card p-6 md:p-8 group">
                <h3 className="text-[17px] font-medium text-[#0a0a0a] tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-[14px] leading-relaxed text-[#6e6e73] max-w-2xl">
                  {s.body}
                </p>
              </div>
            </li>
          </Reveal>
        ))}
      </ol>
    </div>
  );
}
